import { Avatar, Row } from "antd";
import { useCallback, useState } from "react";
import { ChatModal } from "../ChatModal";
import { MessageOutlined } from "@ant-design/icons";

type ChatOptionProps = {
  accountNumber: string;
  isBuyer: boolean;
};

export const ChatOption = ({ accountNumber, isBuyer }: ChatOptionProps) => {
  const [openChat, setOpenChat] = useState<boolean>(false);

  const openModal = useCallback(() => setOpenChat(true), []);

  return (
    <>
      <Row
        className="align-center px-4 py-2 logo-cursor clickable-item"
        onClick={openModal}
      >
        <Avatar
          icon={<MessageOutlined className="text" />}
          size={40}
          className="option d-flex justify-center"
        />
        <p className="my-0 text-md w-500 ml-4">
          Message {isBuyer ? "Seller" : "Buyer"}
        </p>
      </Row>

      <ChatModal
        open={openChat}
        setOpen={setOpenChat}
        isBuyer={isBuyer}
        accountNumber={+accountNumber}
      />
    </>
  );
};
